import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
//import Services from './components/Services';
import Directors from './components/Directors';
import Services from './components/ServicesNew';
import About from './components/About';
import Stats from './components/Stats';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services />
      <Directors /> 
      <About />
      <Stats />
      <WhyChooseUs />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;